import React, {useEffect, useRef} from "react";
import MisSystemWritebackStatusManager, {
} from "root/s360components/Registration/MisSystemWritebackStatusManager";
import './RegistrationTitle.scss';


const RegistrationTitle = ({school_id, submissionPhrase, data, showMisIcon}) =>
{

    return (
        <div className='reg-title-grid'>
            <div className='reg-title'>
                <h3 style={{color: submissionPhrase.textColor}}>{submissionPhrase.title}</h3>
            </div>
            <div className='mis-status'>
                {showMisIcon === true && <MisSystemWritebackStatusManager school_id={school_id} data={data}/>}
            </div>
        </div>
    )
}

export default RegistrationTitle;